module.exports = __webpack_public_path__ + "static/fonts/open-sans-regular.5f4d4bc.eot";